export default function Training({
                                     title = "Training & Skill Verification",
                                     badge = "PRE-DEPLOYMENT TRAINING",
                                     description = "Every candidate undergoes comprehensive trade evaluation and orientation before deployment to guarantee immediate productivity and compliance.",
                                     features = [
                                         { icon: "fa fa-graduation-cap", text: "Practical Trade Assessment in accredited centers" },
                                         { icon: "fa fa-language", text: "Language Orientation (English & Arabic)" },
                                         { icon: "fa fa-book-reader", text: "Work Ethics & Cultural Adaptation Sessions" }
                                     ],
                                     imageSrc = "44.png",
                                     reverse = false
                                 }) {
    return (
        <section
            className="training-area pt-60 pb-80 position-relative overflow-hidden"
            style={{
                backgroundImage: 'url("42.png")',
                backgroundSize: 'contain',
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#ffffff'
            }}
        >
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className={`row align-items-center g-5 ${reverse ? 'flex-row-reverse' : ''}`}>
                    {/* Left Text Content */}
                    <div className="col-lg-6" >
                        <div className="training-content">
                            {badge && (
                                <span className="badge bg-dark text-white border px-3 py-2 mb-3 fw-semibold rounded-pill">
                                    {badge}
                                </span>
                            )}
                            <h2 className="fw-bold mb-3" style={{ color: '#0f172a' }}>{title}</h2>
                            {description && (
                                <p className="text-dark mb-4" align="justify">
                                    {description}
                                </p>
                            )}

                            <ul className="list-unstyled">
                                {features.map((item, index) => (
                                    <li key={index} className="d-flex align-items-center mb-3">
                                        <div className="flex-shrink-0 text-dark fs-5 me-3">
                                            <i className={item.icon || "fa fa-check-circle"}></i>
                                        </div>
                                        <span className="text-dark fw-medium">{item.text}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Right Image Side */}
                    <div className="col-lg-6">
                        <div className="training-img text-center">
                            <img
                                src={imageSrc}
                                alt={title}
                                className="img-fluid w-100 shadow-sm"
                                style={{ borderRadius: '40px', objectFit: 'cover', maxHeight: '480px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}